import setup from './moduleSetup';

export default {
    name: 'rma',
    before: [],
    after: [],
    setup,
};
